var hearingHealthPartners = [
    'UnitedHealthCare',
    'NCD',
    'FSA or HSA Plan',
    "Sam's Club",
    'Military',
    'First Responder',
    'Costco Wholesale',
];
export var hearingHealthPartnersSalesforceValues = [
    'UNITED_HEALTH_CARE',
    'NCD',
    'FSA_OR_HSA_PLAN',
    'SAMS_CLUB',
    'MILITARY',
    'FIRST_RESPONDER',
    'COSTCO_WHOLESALE',
];
export var salesforceValueToHearingHealthPartnerMap = {
    UNITED_HEALTH_CARE: 'UnitedHealthCare',
    NCD: 'NCD',
    FSA_OR_HSA_PLAN: 'FSA or HSA Plan',
    SAMS_CLUB: "Sam's Club",
    MILITARY: 'Military',
    FIRST_RESPONDER: 'First Responder',
    COSTCO_WHOLESALE: 'Costco Wholesale',
};
export var hearingHealthPartnerLeadsourceMap = { lxe_heardigits_ncd: 'NCD' };
export var hearingHealthPartnerReferralLinkMap = {
    lxe_heardigits_ncd: {
        production: 'https://lxehearing.com/partners/ncd',
        staging: 'https://lxe-partners.eargo.com/partners/ncd',
        development: 'https://lxe-partners.eargo.com/partners/ncd',
    },
};
